import { render, staticRenderFns } from "./BookingAdjustmentForm.vue?vue&type=template&id=0fd463ca&"
import script from "./BookingAdjustmentForm.vue?vue&type=script&lang=js&"
export * from "./BookingAdjustmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports